let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ejGmj")).then(() => parcelRequire('cHwqN'));